var slidetoggleInit = function (buttonObj, slideObj ) {

    var slide = slideObj;
    buttonObj
        .show()
        .css('visibility', 'visible')
        .attr({
               'aria-expanded': 'false',
               'aria-selected': 'false'              
           });

    slide.hide();
    slide.attr({ 'aria-hidden': 'true'});

    buttonObj.on("mousedown keypress", function (evt) {
        evt.preventDefault();
        $(this)
               .toggleClass('active');

        var collapsibleElement =
         $(this).next(slide);

        var isNotSlidingEffect = $(this).is("[data-no-sliding]");

        if(!isNotSlidingEffect)
        {       
            collapsibleElement
                .slideToggle();
        }
        else{//Like in the tooltips we don't need to have slider effect 
            var isActive = $(this).hasClass("active");

            if(isActive)
            {
                collapsibleElement
                    .css('display','block');
                    
            }else{

                collapsibleElement
                    .hide();
            }
        }

        collapsibleElement
            .toggleClass('open');

        //adding aria-attributes
        if (slide.hasClass('open')) {
            $(this)
                .attr({
                    'aria-expanded': 'true',
                    'aria-selected': 'true'
                });

            collapsibleElement.
            attr({ 'aria-hidden': 'false'});
        }
        else {
            $(this)
                .attr({
                    'aria-expanded': 'false',
                    'aria-selected': 'false'
                });

            collapsibleElement.
            attr({ 'aria-hidden': 'true'});
        }
    });

    // Concertina - first item open settings
    $('[data-toggle-status="first-open"]').each(function () {
        _firstSlide = $(this).find(slide).first();
        _firstSlide
            .show()
            .attr({
                'aria-expanded': 'true',
                'aria-selected': 'true',
                'aria-hidden': 'false'
            })
            .addClass('open')
            .prev(buttonObj).addClass('active');
    });
}
